import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

import { ConfirmationDialogBaseComponent } from '@ups/xplat/features';

@Component({
  selector: 'ups-confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent extends ConfirmationDialogBaseComponent {
  // WI 31903: `show` is toggled imperatively via the ViewChild open() path, so it
  // must be a signal to re-render the @if under OnPush + zoneless.
  readonly show = signal(false);
  constructor() {
    super();
  }

  /**
   * @param message What message should be shown on the dialog?
   * @param confirmCallback This function is ran whenever the dialog is confirmed
   * @param cancelCallback This function is called if the dialog is cancelled
   */
  open(
    message?: string,
    confirmCallback?: () => void,
    cancelCallback?: () => void
  ) {
    super.open(message, confirmCallback, cancelCallback);
    this.show.set(true);
  }

  onConfirm() {
    super.onConfirm();
    this.show.set(false);
  }

  onCancel() {
    super.onCancel();
    this.show.set(false);
  }
}
